import axios from "axios";
import {DEFAULT_SERVICE} from "../shared/constants";
import {toast} from "react-toastify";
import {getElementsByClassNameAndDefineClass} from "../utils";

/**
 * Create an Axios Client with defaults
 */
const client = axios.create({
    baseURL: DEFAULT_SERVICE,
});
/**
 * Request Wrapper with default success/error actions
 */
const request = function (options, changeSpinnerStatus = () => {}) {
    getElementsByClassNameAndDefineClass("spinner-none", "spinner spinner-border");
    getElementsByClassNameAndDefineClass("content-body", "content-body content-body-loading");
    const selectedLanguage = localStorage.getItem("i18nextLng");
    options.headers = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        GLASLang: selectedLanguage == undefined ? "tr" : selectedLanguage,
        ...options.headers
    };

    changeSpinnerStatus(true);
    const onSuccess = function (response) {
        setTimeout(() => { changeSpinnerStatus(false) }, 500)
        console.debug("Request Successful!", response);
        if (response.data.warnings && response.data.warnings.length > 0) {
            response.data.warnings.forEach(w =>
                toast.warning(w, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                }))
        }
        if (response.data.messages && response.data.messages.length > 0) {
            response.data.messages.forEach(m =>
                toast.error(m, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                }))
        }
        getElementsByClassNameAndDefineClass("content-body", "content-body");
        getElementsByClassNameAndDefineClass("spinner", "spinner-none spinner-border");
        return response.data.messages ? response.data : response;
    };

    const onError = function (error) {
        setTimeout(() => { changeSpinnerStatus(false) }, 500)

        if (error.response.data.messages && error.response.data.messages.length > 0) {
            error.response.data.messages.forEach(m =>
                toast.error(m, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                }))
        }

        // console.error("Request Failed:", error.config);

        // if (error.response) {
        //     // Request was made but server responded with something
        //     // other than 2xx
        //     console.error("Status:", error.response.status);
        //     console.error("Data:", error.response.data);
        //     console.error("Headers:", error.response.headers);
        // } else {
        //     // Something else happened while setting up the request
        //     // triggered the error
        //     console.error("Error Message:", error.message);
        // }
        getElementsByClassNameAndDefineClass("content-body", "content-body");
        getElementsByClassNameAndDefineClass("spinner", "spinner-none spinner-border");

//        return Promise.reject(error.response || error.message);
        return error.response.data.messages ? error.response.data : error.response;

    };

    return client(options).then(onSuccess).catch(onError);
};

export default request;